import {
  Box,
  HStack,
  Heading,
  Text,
} from '@chakra-ui/react'
import { ReactNode } from 'react'

interface PageHeaderProps {
  title: string
  description?: string
  actions?: ReactNode
}

export function PageHeader({ title, description, actions }: PageHeaderProps) {
  return (
    <HStack justify="space-between" align="start" mb={6}>
      <Box>
        <Heading size="lg" mb={2}>
          {title}
        </Heading>
        {description && <Text color="fg.muted">{description}</Text>}
      </Box>
      {actions && <HStack gap={2}>{actions}</HStack>}
    </HStack>
  )
}
